import { DeleteOutline } from '@mui/icons-material';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { arrayRemove, doc, setDoc } from 'firebase/firestore';
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Recommender } from '../../consts/types/user';
import { db } from '../../firebase';
import { UserSelectors, userActionsCreators } from '../../reducers/user';
import ItemMenu from '../Common/ItemMenu';
import AddRecommenderDialog from './Dialogs/AddRecommenderDialog';
const { NotificationManager } = require('react-notifications');


interface RecommendationsProps {

}

type Props = RecommendationsProps;


const Recommendations: FC<Props> = (props: Props) => {
    const user = useSelector(UserSelectors.currentUser);
    const [recommenders, setRecommenders] = useState(user?.recommenders || []);
    const [isSaving, setIsSaving] = useState(false);
    const [isAddingRecommender, setIsAddingRecommender] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        setRecommenders(user?.recommenders || []);
    }, [user?.recommenders]); //eslint-disable-line

    const removeRecommender = (rec: Recommender) => () => {
        if (user?.email) {
            const updatedRecommenders = recommenders.filter(r => r.name !== rec.name || r.role !== rec.role || r.email !== rec.email);
            setIsSaving(true);
            if (user) {
                dispatch(userActionsCreators.setUser({ user: { ...user, recommenders: updatedRecommenders } }));
            }
            setDoc(doc(db, "users", user.email), {
                recommenders: arrayRemove(rec),
            }, { merge: true })
                .then((result) => {
                    setIsSaving(false);
                    NotificationManager.success('Changes were saved successfully!',);
                })
                .catch(() => {
                    setIsSaving(false);
                    NotificationManager.error('Something went wrong. Please try again.',);
                });
        }
    }

    return <Box display="flex" flexDirection="column" pb={{ xs: 1, md: 2 }} flex={1} gap={1}>
        {/* {isStepNotComplete(UserProfileStep.Recommendations) && <Alert severity='warning' sx={{ display: { xs: "flex", md: "none" } }}>Step is not completed yet</Alert>} */}
        {/* <Typography fontSize="0.875rem" color="text.secondary">Your recommenders contact information. We will send them an email to receive their recommendations.</Typography> */}
        <Card variant="outlined">
            <CardContent>
                <Box borderRadius="4px" sx={{ overflowY: "auto" }} >
                    <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
                        <Box display="flex" alignItems="center">
                            <Typography color="primary" fontWeight={500} >RECOMMENDERS</Typography>
                            {isSaving && <CircularProgress sx={{ width: "18px  !important", height: "18px !important", ml: 1 }} />}
                        </Box>
                        <Button variant="outlined" size="small" onClick={() => { setIsAddingRecommender(true) }}>+ Add </Button>
                    </Box>

                    {recommenders?.map((rec, index) => <Card key={rec.email + index} sx={{ mt: 2 }} variant="outlined">
                        <CardContent >
                            <Box display="flex" justifyContent="space-between" alignItems="flex-end">
                                <Typography color="primary" fontWeight={400} fontSize={{ xs: "1rem", md: "1.1rem" }} component="div">
                                    {rec.name}
                                </Typography>
                                <Box display="flex">
                                    <ItemMenu items={[{
                                        label: "Delete",
                                        icon: <DeleteOutline fontSize='small' color="inherit" />,
                                        onClick: removeRecommender(rec)
                                    }]} />
                                </Box>
                            </Box>
                            {rec.role && <Typography fontSize={{ xs: "0.8rem !important", md: "0.875rem !important" }} >
                                {rec.role}
                            </Typography>}
                            <Typography color="text.secondary" fontSize={{ xs: "0.8rem !important", md: "0.875rem !important" }} mt={1}>
                                {rec.email}
                            </Typography>
                            <Typography color="text.secondary" fontSize={{ xs: "0.8rem !important", md: "0.875rem !important" }}>
                                {rec.phone}
                            </Typography>

                            {/* <Typography mt={1} fontWeight={500} color={getFieldStatusColor(rec.status,)} fontSize={{ xs: "0.7rem", md: "0.875rem" }}>
                        {rec.status}
                    </Typography> */}
                        </CardContent>
                    </Card>)}
                </Box>
            </CardContent>
        </Card>
        <AddRecommenderDialog isAddingRecommender={isAddingRecommender}
            isSavingRecommender={isSaving}
            setIsAddingRecommender={setIsAddingRecommender}
            setIsSavingRecommender={setIsSaving} />

    </Box>;
}


export default Recommendations;

